
import { Component, Vue } from 'vue-property-decorator';

import { ERouteDisclaimerMessage } from '@/router/validators/enums';

type Disclaimers = Record<ERouteDisclaimerMessage, string>;

@Component({})
export default class UseLefBarDisclaimers extends Vue {
  get tPrefix() {
    return 'common.routeDisclaimers';
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'] || {};
  }

  get disclaimers(): Record<ERouteDisclaimerMessage, string> {
    if (!this.businessInfo)
      return {} as Record<ERouteDisclaimerMessage, string>;

    return Object.values(ERouteDisclaimerMessage).reduce(
      (acc, disclaimerKey) => ({
        ...acc,
        [disclaimerKey]: String(
          this.$t(`${this.tPrefix}.${disclaimerKey}`, {
            country: this.businessInfo.country
          })
        )
      }),
      {} as Disclaimers
    );
  }
}
